module.exports = __webpack_public_path__ + "img/sms_template.2f84ec68.svg";